import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function useOfficial(meetingId, onChanged) {
  const [doc, setDoc] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState("idle");
  const timer = useRef(null);
  useEffect(() => { api.get(`/meetings/${meetingId}/official`).then((r) => setDoc(r.data)); }, [meetingId]);
  const generate = async (output_language) => {
    setBusy(true);
    try { const d = (await api.post(`/meetings/${meetingId}/official`, { output_language }, { timeout: 180000 })).data; setDoc(d); onChanged?.(d); return true; }
    catch (e) { toast.error(formatApiError(e)); return false; }
    finally { setBusy(false); }
  };
  const update = (content) => {
    setDoc((d) => ({ ...d, content }));
    setSaved("saving");
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try { await api.put(`/meetings/${meetingId}/official`, content); setSaved("saved"); } catch (e) { setSaved("idle"); toast.error(formatApiError(e)); }
    }, 900);
  };
  return { doc, busy, saved, generate, update };
}
